const initialState = {
  openSidebar: true
};

export function sidebar(state = initialState, action) {
  switch (action.type) {
    case 'SIDEBAR/SET_OPEN':
      return {
        ...state,
        openSidebar: action.payload
      }

    default:
      return state;
  }
}
